module.exports = __webpack_public_path__ + "img/Innovation_Lab_LOGO_weiss_cyan.png";